import './RedeemStatusBadge.css';

function RedeemStatusBadge({ status, isExpired }) {
  const getStatusText = () => {
    if (status === 3) {
      return isExpired ? 'Expired' : 'Redeemable';
    }
    if (status === 4) {
      return 'Closed';
    }
    return 'Unknown';
  };

  const getStatusClass = () => {
    if (status === 3) {
      return isExpired ? 'redeem-status-badge--expired' : 'redeem-status-badge--redeemable';
    }
    if (status === 4) {
      return 'redeem-status-badge--closed';
    }
    return 'redeem-status-badge--unknown';
  };

  return (
    <span className={`redeem-status-badge ${getStatusClass()}`}>
      {getStatusText()}
    </span>
  );
}

export default RedeemStatusBadge;
